import { categories } from './homeData';

export const categoryMovies: Record<string, {
  id: number;
  title: string;
  year: number;
  rating: number;
  description: string;
  image: string;
  tags: string[];
}[]> = {
  dianying: [
    {
      id: 101,
      title: '星际迷航：新纪元',
      year: 2026,
      rating: 8.7,
      description: '人类在星际探索中发现全新文明，一场跨越银河系的冒险就此展开。',
      image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20spaceship%20and%20distant%20galaxy%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20coral%20and%20gold%20color%20accents%2C%20movie%20poster%20style%2C%20clean%20background&width=600&height=800&seq=hongtao-cat-movie-01&orientation=portrait',
      tags: ['科幻', '冒险', '动作'],
    },
    {
      id: 102,
      title: '逆光而行',
      year: 2026,
      rating: 8.5,
      description: '一位盲人摄影师用心灵捕捉世界之美，感人至深的励志故事。',
      image: 'https://readdy.ai/api/search-image?query=Artistic%20drama%20film%20poster%2C%20silhouette%20of%20person%20with%20camera%20against%20warm%20sunset%20light%2C%20emotional%20cinematic%20atmosphere%2C%20soft%20golden%20hour%20lighting&width=600&height=800&seq=hongtao-cat-movie-02&orientation=portrait',
      tags: ['剧情', '励志', '文艺'],
    },
    {
      id: 103,
      title: '流浪地球3',
      year: 2026,
      rating: 9.0,
      description: '人类命运共同体面对太阳危机，展开史诗级太空救援行动。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20blockbuster%20poster%2C%20massive%20planet%20engines%20in%20space%2C%20epic%20scale%2C%20dramatic%20cosmic%20lighting%2C%20grand%20cinematic%20composition%2C%20warm%20coral%20and%20deep%20space%20contrast&width=600&height=800&seq=hongtao-cat-movie-03&orientation=portrait',
      tags: ['科幻', '灾难', '冒险'],
    },
    {
      id: 104,
      title: '唐人街探案4',
      year: 2026,
      rating: 8.3,
      description: '唐仁和秦风再度携手，在东京破解离奇案件，笑料与悬疑齐飞。',
      image: 'https://readdy.ai/api/search-image?query=Comedy%20mystery%20movie%20poster%2C%20detective%20theme%20with%20magnifying%20glass%2C%20urban%20night%20scene%2C%20playful%20yet%20suspenseful%20atmosphere%2C%20warm%20neon%20lighting%2C%20entertaining%20composition&width=600&height=800&seq=hongtao-cat-movie-04&orientation=portrait',
      tags: ['喜剧', '悬疑', '动作'],
    },
    {
      id: 105,
      title: '深海危机',
      year: 2026,
      rating: 8.1,
      description: '深海科考队意外发现未知生物，一场惊心动魄的深海逃生。',
      image: 'https://readdy.ai/api/search-image?query=Thriller%20movie%20poster%2C%20deep%20ocean%20darkness%20with%20mysterious%20glow%2C%20submarine%20silhouette%2C%20suspenseful%20atmosphere%2C%20cinematic%20horror%20undertone%2C%20cool%20blue%20and%20warm%20coral%20contrast&width=600&height=800&seq=hongtao-cat-movie-05&orientation=portrait',
      tags: ['惊悚', '科幻', '冒险'],
    },
    {
      id: 106,
      title: '长安夜未央',
      year: 2026,
      rating: 8.8,
      description: '大唐盛世下的爱情传奇，跨越时空的绝美之恋。',
      image: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20historical%20film%20poster%2C%20ancient%20Tang%20Dynasty%20palace%20under%20moonlight%2C%20couple%20in%20traditional%20robes%2C%20poetic%20atmosphere%2C%20warm%20golden%20lantern%20light%2C%20elegant%20composition&width=600&height=800&seq=hongtao-cat-movie-06&orientation=portrait',
      tags: ['爱情', '历史', '古装'],
    },
  ],
  dianshiju: [
    {
      id: 201,
      title: '长安十二时辰',
      year: 2026,
      rating: 9.2,
      description: '大唐盛世下的悬疑惊险故事，十二时辰内拯救长安城的壮丽史诗。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20ancient%20Tang%20Dynasty%20city%20scene%2C%20warm%20golden%20lighting%2C%20traditional%20architecture%2C%20dramatic%20cinematic%20composition%2C%20elegant%20mysterious%20atmosphere&width=600&height=800&seq=hongtao-cat-tv-01&orientation=portrait',
      tags: ['古装', '悬疑', '历史'],
    },
    {
      id: 202,
      title: '风云再起',
      year: 2026,
      rating: 8.6,
      description: '商界风云变幻，一群年轻人在时代浪潮中拼搏奋斗的励志故事。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20business%20drama%20poster%2C%20young%20professionals%20in%20city%20skyline%2C%20sophisticated%20urban%20atmosphere%2C%20warm%20cinematic%20lighting&width=600&height=800&seq=hongtao-cat-tv-02&orientation=portrait',
      tags: ['都市', '商战', '励志'],
    },
    {
      id: 203,
      title: '庆余年第三季',
      year: 2026,
      rating: 9.3,
      description: '范闲在权力漩涡中步步为营，揭开层层迷雾背后的惊天秘密。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20costume%20drama%20poster%2C%20martial%20arts%20hero%20in%20ancient%20setting%2C%20dramatic%20lighting%2C%20sword%20and%20silk%2C%20epic%20historical%20fantasy%2C%20rich%20warm%20golden%20tones&width=600&height=800&seq=hongtao-cat-tv-03&orientation=portrait',
      tags: ['古装', '权谋', '武侠'],
    },
    {
      id: 204,
      title: '星辰大海',
      year: 2026,
      rating: 8.4,
      description: '一群航天人追逐星辰梦想，见证中国航天事业的辉煌历程。',
      image: 'https://readdy.ai/api/search-image?query=Space%20themed%20Chinese%20TV%20drama%20poster%2C%20rocket%20launch%20and%20starry%20sky%2C%20inspiring%20patriotic%20atmosphere%2C%20warm%20cinematic%20lighting%2C%20professional%20aerospace%20theme&width=600&height=800&seq=hongtao-cat-tv-04&orientation=portrait',
      tags: ['都市', '科技', '励志'],
    },
    {
      id: 205,
      title: '暗夜追踪',
      year: 2026,
      rating: 8.7,
      description: '刑警队长追查连环案件，在黑暗中与罪犯展开智慧较量。',
      image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20TV%20drama%20poster%2C%20detective%20in%20rainy%20urban%20night%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20suspenseful%20composition%2C%20warm%20streetlight%20against%20darkness&width=600&height=800&seq=hongtao-cat-tv-05&orientation=portrait',
      tags: ['悬疑', '刑侦', '都市'],
    },
    {
      id: 206,
      title: '我们的时代',
      year: 2026,
      rating: 8.9,
      description: '三个家庭跨越三十年的温情故事，记录中国社会的巨大变迁。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20poster%2C%20multi-generational%20family%20portrait%2C%20warm%20nostalgic%20lighting%2C%20retro%20Chinese%20home%20setting%2C%20heartwarming%20atmosphere%2C%20golden%20memories%20tone&width=600&height=800&seq=hongtao-cat-tv-06&orientation=portrait',
      tags: ['家庭', '年代', '温情'],
    },
  ],
  zongyi: [
    {
      id: 301,
      title: '极限挑战第十季',
      year: 2026,
      rating: 8.9,
      description: '明星嘉宾挑战极限任务，欢笑与泪水交织的真人秀盛宴。',
      image: 'https://readdy.ai/api/search-image?query=Vibrant%20Chinese%20variety%20show%20poster%2C%20celebrities%20in%20dynamic%20action%20poses%2C%20colorful%20energetic%20atmosphere%2C%20bright%20studio%20lighting&width=600&height=800&seq=hongtao-cat-variety-01&orientation=portrait',
      tags: ['真人秀', '竞技', '搞笑'],
    },
    {
      id: 302,
      title: '美食探秘：寻味中国',
      year: 2026,
      rating: 8.8,
      description: '走遍中国大街小巷，探寻最地道的地方美食文化。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20show%20poster%2C%20delicious%20traditional%20Chinese%20cuisine%2C%20warm%20appetizing%20lighting%2C%20steaming%20dishes%2C%20rich%20colors%2C%20food%20photography&width=600&height=800&seq=hongtao-cat-variety-02&orientation=portrait',
      tags: ['美食', '旅行', '文化'],
    },
    {
      id: 303,
      title: '乘风破浪的姐姐2026',
      year: 2026,
      rating: 8.6,
      description: '30+姐姐们再次集结，用舞台证明年龄只是数字。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20singing%20competition%20show%20poster%2C%20female%20performers%20on%20stage%2C%20glamorous%20lighting%2C%20concert%20atmosphere%2C%20empowering%20vibe%2C%20sparkling%20stage%20effects&width=600&height=800&seq=hongtao-cat-variety-03&orientation=portrait',
      tags: ['音乐', '竞演', '女性'],
    },
    {
      id: 304,
      title: '脱口秀大会第七季',
      year: 2026,
      rating: 8.5,
      description: '新老脱口秀演员同台竞技，用幽默解读生活的酸甜苦辣。',
      image: 'https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20poster%2C%20comedian%20on%20stage%20with%20microphone%2C%20spotlight%2C%20warm%20theater%20atmosphere%2C%20entertaining%20and%20fun%2C%20clean%20composition&width=600&height=800&seq=hongtao-cat-variety-04&orientation=portrait',
      tags: ['脱口秀', '喜剧', '语言'],
    },
    {
      id: 305,
      title: '奔跑吧兄弟2026',
      year: 2026,
      rating: 8.3,
      description: '跑男团再度出发，全新游戏挑战带来无限欢乐。',
      image: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20game%20show%20poster%2C%20celebrities%20running%20and%20laughing%2C%20sunny%20outdoor%20scene%2C%20colorful%20energetic%20vibe%2C%20fun%20atmosphere&width=600&height=800&seq=hongtao-cat-variety-05&orientation=portrait',
      tags: ['户外', '游戏', '搞笑'],
    },
    {
      id: 306,
      title: '声入人心第五季',
      year: 2026,
      rating: 9.0,
      description: '美声与流行的完美融合，用歌声传递音乐的力量。',
      image: 'https://readdy.ai/api/search-image?query=Classical%20music%20crossover%20show%20poster%2C%20singer%20on%20elegant%20stage%2C%20golden%20spotlight%2C%20sophisticated%20concert%20atmosphere%2C%20warm%20rich%20lighting&width=600&height=800&seq=hongtao-cat-variety-06&orientation=portrait',
      tags: ['音乐', '美声', '竞演'],
    },
  ],
  dongman: [
    {
      id: 401,
      title: '暗影猎手',
      year: 2026,
      rating: 9.0,
      description: '少年在黑暗中觉醒猎手之力，踏上守护世界的热血旅程。',
      image: 'https://readdy.ai/api/search-image?query=Anime-style%20dark%20fantasy%20poster%2C%20young%20warrior%20with%20mystical%20powers%2C%20dramatic%20lighting%2C%20cool%20character%20design%2C%20Japanese%20animation%20aesthetic&width=600&height=800&seq=hongtao-cat-anime-01&orientation=portrait',
      tags: ['热血', '奇幻', '战斗'],
    },
    {
      id: 402,
      title: '进击的巨人最终季',
      year: 2026,
      rating: 9.5,
      description: '人类与巨人之间的终极对决，自由之翼将飞向何方。',
      image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20poster%2C%20giant%20titan%20and%20soldiers%20in%20dramatic%20battle%2C%20cinematic%20anime%20style%2C%20intense%20action%2C%20dramatic%20sky%2C%20warm%20coral%20sunset%20lighting&width=600&height=800&seq=hongtao-cat-anime-02&orientation=portrait',
      tags: ['热血', '战斗', '奇幻'],
    },
    {
      id: 403,
      title: '哪吒之魔童闹海',
      year: 2026,
      rating: 9.3,
      description: '哪吒重生归来，在东海掀起滔天巨浪，谱写新的神话传奇。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%2C%20mythological%20hero%20with%20fire%20powers%2C%20dramatic%20dynamic%20pose%2C%20Chinese%20ink%20painting%20style%2C%20epic%20fantasy%2C%20warm%20red%20and%20gold&width=600&height=800&seq=hongtao-cat-anime-03&orientation=portrait',
      tags: ['国漫', '神话', '动作'],
    },
    {
      id: 404,
      title: '深海',
      year: 2026,
      rating: 8.9,
      description: '少女坠入神秘深海世界，开启一段关于勇气与成长的奇幻之旅。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%2C%20underwater%20fantasy%20world%2C%20colorful%20sea%20creatures%2C%20dreamy%20atmosphere%2C%20beautiful%20ink%20wash%20painting%20style%2C%20warm%20vibrant%20colors&width=600&height=800&seq=hongtao-cat-anime-04&orientation=portrait',
      tags: ['国漫', '奇幻', '治愈'],
    },
    {
      id: 405,
      title: '鬼灭之刃：无限城篇',
      year: 2026,
      rating: 9.4,
      description: '炭治郎与众柱集结，在无限城中展开最终决战。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%2C%20demon%20slayer%20with%20sword%2C%20intense%20action%20scene%2C%20dramatic%20fire%20and%20water%20effects%2C%20dynamic%20composition&width=600&height=800&seq=hongtao-cat-anime-05&orientation=portrait',
      tags: ['日漫', '热血', '战斗'],
    },
    {
      id: 406,
      title: '时光代理人第三季',
      year: 2026,
      rating: 9.1,
      description: '进入照片改变过去，时光代理人面临最艰难的抉择。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20series%20poster%2C%20two%20young%20men%20with%20mysterious%20time%20powers%2C%20urban%20night%20scene%2C%20warm%20neon%20lighting%2C%20stylish%20modern%20aesthetic&width=600&height=800&seq=hongtao-cat-anime-06&orientation=portrait',
      tags: ['国漫', '悬疑', '奇幻'],
    },
  ],
  jilupian: [
    {
      id: 501,
      title: '地球脉动：海洋深处',
      year: 2026,
      rating: 9.5,
      description: '潜入深海探索未知世界，呈现海洋生命的壮丽奇观。',
      image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20deep%20ocean%20with%20bioluminescent%20sea%20creatures%2C%20majestic%20underwater%20scene%2C%20cinematic%20documentary%20style%2C%20vibrant%20marine%20life&width=600&height=800&seq=hongtao-cat-doc-01&orientation=portrait',
      tags: ['自然', '海洋', 'BBC'],
    },
    {
      id: 502,
      title: '航拍中国第五季',
      year: 2026,
      rating: 9.3,
      description: '从空中俯瞰壮美中国，用全新视角发现祖国的山河之美。',
      image: 'https://readdy.ai/api/search-image?query=Aerial%20photography%20documentary%20poster%2C%20stunning%20Chinese%20landscape%20from%20above%2C%20mountains%20and%20rivers%2C%20golden%20sunlight%2C%20majestic%20natural%20scenery&width=600&height=800&seq=hongtao-cat-doc-02&orientation=portrait',
      tags: ['自然', '地理', '中国'],
    },
    {
      id: 503,
      title: '大国工匠',
      year: 2026,
      rating: 9.1,
      description: '记录中国顶尖工匠的精湛技艺，传承千年的匠人精神。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20craftsmanship%20documentary%20poster%2C%20artisan%20hands%20working%20on%20traditional%20craft%2C%20warm%20workshop%20lighting%2C%20detailed%20close-up%2C%20heritage%20and%20skill&width=600&height=800&seq=hongtao-cat-doc-03&orientation=portrait',
      tags: ['人文', '工艺', '传承'],
    },
    {
      id: 504,
      title: '宇宙时空之旅',
      year: 2026,
      rating: 9.4,
      description: '从大爆炸到生命诞生，一场穿越时空的宇宙探索之旅。',
      image: 'https://readdy.ai/api/search-image?query=Space%20documentary%20poster%2C%20cosmic%20nebula%20and%20stars%2C%20galaxy%20spiral%2C%20awe-inspiring%20universe%2C%20deep%20space%20photography%2C%20scientific%20and%20beautiful&width=600&height=800&seq=hongtao-cat-doc-04&orientation=portrait',
      tags: ['科学', '宇宙', '探索'],
    },
    {
      id: 505,
      title: '舌尖上的中国2026',
      year: 2026,
      rating: 9.2,
      description: '全新一季美食探索，发现中国饮食文化的深厚底蕴。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20steaming%20hot%20traditional%20dishes%2C%20rustic%20kitchen%20scene%2C%20warm%20natural%20lighting%2C%20appetizing%20food%20photography&width=600&height=800&seq=hongtao-cat-doc-05&orientation=portrait',
      tags: ['美食', '文化', '人文'],
    },
    {
      id: 506,
      title: '蓝色星球：珊瑚秘境',
      year: 2026,
      rating: 9.3,
      description: '探索全球珊瑚礁生态系统，揭开海底花园的神秘面纱。',
      image: 'https://readdy.ai/api/search-image?query=Underwater%20documentary%20poster%2C%20vibrant%20coral%20reef%20with%20tropical%20fish%2C%20crystal%20clear%20water%2C%20sunlight%20rays%2C%20beautiful%20marine%20ecosystem&width=600&height=800&seq=hongtao-cat-doc-06&orientation=portrait',
      tags: ['自然', '海洋', '生态'],
    },
  ],
};

export const categoryInfo = Object.fromEntries(
  categories.map((cat) => [cat.slug, cat])
);